export default function jwtDecode(token) {
  const [encHeader, encPayload, encSignature] = token.split('.');

  return {
    header: JSON.parse(atob(encHeader)),
    payload: JSON.parse(atob(encPayload)),
    signature: encSignature,
  };
}
